import React from "react";
import { IconButton, TableCell, TableRow, MenuItem, TextField } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { IWorker } from "../../../interfaces/IWorker";

interface IProps {
    worker: IWorker;
    setWorkerArray: (w: IWorker, action: "remove" | "update") => void;
}

export const WorkerTableRow: React.FC<IProps> = ({ worker, setWorkerArray }) => {
    const handleRemoveWorker = () => {
        setWorkerArray(worker, "remove");
    };

    const handleChangeRole = (e: React.ChangeEvent<HTMLInputElement>) => {
        const roleId = Number(e.target.value);
        const updatedWorker: IWorker = {
            ...worker,
            ProjectRole: {
                id: roleId,
                role: getRoleName(roleId),
            },
        };
        setWorkerArray(updatedWorker, "update");
    };

    const getRoleName = (id: number): string => {
        return id === 4 ? "Innendienst" : id === 6 ? "Außendienst" : "Bauleiter";
    };

    return (
        <TableRow sx={{ backgroundColor: "white" }}>
            <TableCell>{worker.Profile.id}</TableCell>
            <TableCell>{`${worker.Profile.User.first_name} ${worker.Profile.User.last_name}`}</TableCell>
            <TableCell>
                <TextField value={worker.ProjectRole.id} onChange={handleChangeRole} size="small" select fullWidth>
                    {[4, 6, 7].map((id) => (
                        <MenuItem key={id} value={id}>
                            {getRoleName(id)}
                        </MenuItem>
                    ))}
                </TextField>
            </TableCell>
            <TableCell>{worker.Profile.mobile_number}</TableCell>
            <TableCell>{worker.Profile.User.email}</TableCell>
            <TableCell>
                <IconButton size="small" onClick={handleRemoveWorker}>
                    <Delete />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};
